<template>
  <div class="page-passengers">
    <base-timeline></base-timeline>

    <form class="base-form" @submit.prevent="submitForm">
      <base-section v-if="passengersCount">
        <div class="container">
          <h2 class="title title-bigger title-semi text-center">{{$t('views.passengers.title')}}</h2>

          <div class="passengers">
            <base-card class="base-card-passenger passenger" v-for="(passenger, index) in passengersForm" :key="index">
              <h3 class="title title-smaller title-caps title-light"><i class="fa-light fa-user"></i> {{$t('booking.passenger')}} #{{ index + 1 }}</h3>

              <div class="base-form-fields">
                <!-- First Name -->
                <div class="base-form-field base-form-field-1-3">
                  <label class="text text-clear" :for="`passenger_${index}_first_name`">{{$t('booking.first_name')}} *</label>
                  <input
                    type="text"
                    :name="`passenger_${index}_first_name`"
                    :id="`passenger_${index}_first_name`"
                    v-model="passenger.first_name"
                    :class="{ error: errors[index]?.first_name }"
                    @input="clearError( index, 'first_name' )"
                  >
                  <div class="base-form-field-error" v-if="errors[index]?.first_name">
                    <span class="text text-tiny text-red">{{$t( getErrorI18nKey( errors[index].first_name ) )}}</span>
                  </div>
                </div>

                <!-- Last Name -->
                <div class="base-form-field base-form-field-1-3">
                  <label class="text text-clear" :for="`passenger_${index}_last_name`">{{$t('booking.last_name')}} *</label>
                  <input
                    type="text"
                    :name="`passenger_${index}_last_name`"
                    :id="`passenger_${index}_last_name`"
                    v-model="passenger.last_name"
                    :class="{ error: errors[index]?.last_name }"
                    @input="clearError( index, 'last_name' )"
                  >
                  <div class="base-form-field-error" v-if="errors[index]?.last_name">
                    <span class="text text-tiny text-red">{{$t( getErrorI18nKey( errors[index].last_name ) )}}</span>
                  </div>
                </div>

                <!-- Employee Number -->
                <div class="base-form-field base-form-field-1-3">
                  <label class="text text-clear" :for="`passenger_${index}_employee_number`">{{$t('booking.employee_number')}}</label>
                  <input
                    type="text"
                    :name="`passenger_${index}_employee_number`"
                    :id="`passenger_${index}_employee_number`"
                    v-model="passenger.employee_number"
                    :class="{ error: errors[index]?.employee_number }"
                    @input="clearError( index, 'employee_number' )"
                  >
                  <div class="base-form-field-error" v-if="errors[index]?.employee_number">
                    <span class="text text-tiny text-red">{{$t( getErrorI18nKey( errors[index].employee_number ) )}}</span>
                  </div>
                </div>

                <!-- Email -->
                <div class="base-form-field base-form-field-1-3">
                  <label class="text text-clear" :for="`passenger_${index}_email`">{{$t('booking.email')}} *</label>
                  <input
                    type="text"
                    :name="`passenger_${index}_email`"
                    :id="`passenger_${index}_email`"
                    v-model="passenger.email"
                    :class="{ error: errors[index]?.email }"
                    @input="clearError( index, 'email' )"
                  >
                  <div class="base-form-field-error" v-if="errors[index]?.email">
                    <span class="text text-tiny text-red">{{$t( getErrorI18nKey( errors[index].email ) )}}</span>
                  </div>
                </div>

                <!-- Email Copy -->
                <div class="base-form-field base-form-field-1-3">
                  <label class="text text-clear" :for="`passenger_${index}_email_copy`">{{$t('booking.email_copy')}}</label>
                  <input
                    type="text"
                    :name="`passenger_${index}_email_copy`"
                    :id="`passenger_${index}_email_copy`"
                    v-model="passenger.email_copy"
                  >
                </div>

                <!-- Phone -->
                <div class="base-form-field base-form-field-1-3">
                  <label class="text text-clear" :for="`passenger_${index}_phone`">{{$t('booking.phone')}} *</label>
                  <input
                    type="text"
                    :name="`passenger_${index}_phone`"
                    :id="`passenger_${index}_phone`"
                    v-model="passenger.phone"
                    :class="{ error: errors[index]?.phone }"
                    @input="clearError( index, 'phone' )"
                  >
                  <div class="base-form-field-error" v-if="errors[index]?.phone">
                    <span class="text text-tiny text-red">{{$t( getErrorI18nKey( errors[index].phone ) )}}</span>
                  </div>
                </div>
                
                <!-- Sex -->
                <div class="base-form-field base-form-field-1-3">
                  <label class="text text-clear" :for="`passenger_${index}_sex`">{{$t('booking.sex')}} *</label>
                  <select
                    :name="`passenger_${index}_sex`"
                    :id="`passenger_${index}_sex`"
                    v-model="passenger.sex"
                    :class="{ error: errors[index]?.sex }"
                    @input="clearError( index, 'sex' )"
                  >
                    <option disabled value="">{{$t('booking.select_sex')}}</option>
                    <option value="Male">{{$t('booking.male')}}</option>
                    <option value="Female">{{$t('booking.female')}}</option>
                  </select>

                  <div class="base-form-field-error" v-if="errors[index]?.sex">
                    <span class="text text-tiny text-red">{{$t( getErrorI18nKey( errors[index].sex ) )}}</span>
                  </div>
                </div>

                <!-- Passenger Weight -->
                <div class="base-form-field base-form-field-1-3">
                  <label class="text text-clear" :for="`passenger_${index}_passenger_weight`">{{$t('booking.passenger_weight')}} ({{$t('booking.lbs')}}) *</label>
                  <input
                    type="text"
                    :name="`passenger_${index}_passenger_weight`"
                    :id="`passenger_${index}_passenger_weight`"
                    v-model="passenger.passenger_weight"
                    :class="{ error: errors[index]?.passenger_weight }"
                    @input="clearError( index, 'passenger_weight' )"
                  >
                  <div class="base-form-field-error" v-if="errors[index]?.passenger_weight">
                    <span class="text text-tiny text-red">{{$t( getErrorI18nKey( errors[index].passenger_weight ) )}}</span>
                  </div>
                </div>

                <!-- Luggage Weight -->
                <div class="base-form-field base-form-field-1-3">
                  <label class="text text-clear" :for="`passenger_${index}_luggage_weight`">{{$t('booking.baggage_weight')}} ({{$t('booking.lbs')}}) *</label>
                  <input
                    type="text"
                    :name="`passenger_${index}_luggage_weight`"
                    :id="`passenger_${index}_luggage_weight`"
                    v-model="passenger.baggage_weight"
                    :class="{ error: errors[index]?.baggage_weight }"
                    @input="clearError( index, 'baggage_weight' )"
                  >
                  <div class="base-form-field-error" v-if="errors[index]?.baggage_weight">
                    <span class="text text-tiny text-red">{{$t( getErrorI18nKey( errors[index].baggage_weight ) )}}</span>
                  </div>
                </div>

                <!-- Additional Info -->
                <div class="base-form-field">
                  <label class="text text-clear" :for="`passenger_${index}_additional_info`">{{$t('booking.additional_info')}}</label>
                  <input
                    type="text"
                    :name="`passenger_${index}_additional_info`"
                    :id="`passenger_${index}_additional_info`"
                    v-model="passenger.additional_info"
                  >
                </div>
              </div>
            </base-card>
          </div>

          <base-card class="base-card-sec base-card-passenger">
            <p class="text text-small text-white">* {{$t('messages.fields_are_required')}}</p>
            <p class="text text-small text-white">** {{$t('messages.luggage_weight_warning')}}</p>
          </base-card>
        </div>
      </base-section>

      <base-section class="no-padding-top">
        <div class="container">
          <div class="footer-buttons">
            <base-button class="base-button-outline" @click="goPrevious">{{$t('buttons.prev')}}</base-button>
            <base-button class="base-button-pri" type="submit" v-if="formIsValid">{{$t('buttons.next')}}</base-button>
          </div>
        </div>
      </base-section>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BaseTimeline from '@/components/partials/BaseTimeline.vue'

export default {
  components: {
    BaseTimeline: BaseTimeline,
  },
  data() {
    return {
      passengersForm: [],
      errors: [],
      formIsValid: true
    }
  },
  computed: {
    ...mapState( 'optionsModule', [
      'passengersCount'
    ])
  },
  methods: {
    goPrevious() {
      this.$router.push( '/reservation-flights' )
    },
    isEmpty(value) {
      return value === null || value === undefined || value === ''
    },
    isEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    },
    isNumeric(value) {
      return !isNaN(value) && value !== ''
    },
    validateForm() {
      this.formIsValid = true

      const VALIDATION_RULES = {
        first_name: { required: true },
        last_name: { required: true },
        employee_number: { required: false, numeric: true, minchars: 6 },
        email: { required: true, email: true },
        email_copy: { required: false },
        phone: { required: true },
        sex: { required: true },
        passenger_weight: { required: true, numeric: true, min: 1 },
        baggage_weight: { required: true, numeric: true, min: 1 },
        additional_info: { required: false }
      }

      this.errors = this.passengersForm.map(passenger => {
        const fieldErrors = {}

        Object.entries(VALIDATION_RULES).forEach(([field, rules]) => {
          const value = passenger[field]

          // Required
          if( rules.required && this.isEmpty( value ) ) {
            fieldErrors[field] = 'required'
            this.formIsValid = false
            return
          }

          // Optional + empty → skip
          if( this.isEmpty( value ) ) return

          // Email
          if( rules.email && !this.isEmail( value ) ) {
            fieldErrors[field] = 'email'
            this.formIsValid = false
            return
          }

          // Numeric
          if( rules.numeric && !this.isNumeric( value ) ) {
            fieldErrors[field] = 'numeric'
            this.formIsValid = false
            return
          }

          // Min value
          if( rules.min !== undefined && Number( value ) < rules.min ) {
            fieldErrors[field] = 'min'
            this.formIsValid = false
          }

          // Min Characters
          if( rules.minchars !== undefined && value.length < rules.minchars ) {
            fieldErrors[field] = 'min_chars'
            this.formIsValid = false
          }
        })

        return fieldErrors
      })

      return this.formIsValid
    },
    clearError(index, field) {
      if (this.errors[index]?.[field]) {
        delete this.errors[index][field]
      }

      this.formIsValid = this.errors.every(
        passengerErrors => Object.keys(passengerErrors).length === 0
      )
    },
    getErrorI18nKey(errorCode) {
      return `forms.errors.${errorCode || 'invalid'}`
    },
    async submitForm() {
      if( !this.validateForm() ) return
      try {
        await this.$store.dispatch( 'passengersModule/savePassengers', this.passengersForm )
        this.$router.push( '/reservation-revision#base-timeline' )
      } catch( error ) {
        console.log( error )
      }
    },
  },
  mounted() {
    this.$store.commit( 'timelineModule/SET_STEP', 2 )

    const savedPassengers = this.$store.state.passengersModule.passengers
    if( savedPassengers.length ) {
      this.passengersForm = JSON.parse( JSON.stringify( savedPassengers ) )
      return
    }

    this.passengersForm = Array.from(
      { length: this.passengersCount },
      () => ({
        first_name: '',
        last_name: '',
        employee_number: '',
        email: '',
        email_copy: '',
        phone: '',
        sex: '',
        passenger_weight: '',
        baggage_weight: '',
        additional_info: ''
      })
    )

    this.errors = Array.from(
      { length: this.passengersCount },
      () => ({})
    )
  }
}
</script>